import React from 'react'
import { LineChart } from "@carbon/charts-react";
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '.././DashboardConstants';
import { Button, MultiSelect, NumberInput, TextInputSkeleton } from 'carbon-components-react'

const CustomLineChart = (props) => {
    const defaultLineGraphOptions = {
        "axes": {
            "bottom": {
                "title": props.graphXAxisTitle || "Time",
                "mapsTo": "date",
                "scaleType": props.bottomScaleType || "labels"
            },
            "left": {
                "mapsTo": "value",
                "title": props.graphTitle,
                "scaleType": "linear",
                "percentage": props.isPercentage
            }
        },
        "curve": props.selectedUtilizationType === 'averageUtilization' ? DashboardConstants.CurevMonotonex : DashboardConstants.CurveSStepAfter,
        "legend": {
            "position": "bottom",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "data": {
            "loading": props.loading
        },
        "height": "400px"
    };

    return (
        <>
            <div className="dashboard-line-graph">
                <div className="graph-title carbon-display-Regular-20">
                    <div className="graph-action-items graph-label">
                        <div className="label">{props.title}</div>
                        <div>
                            {(props.selectedUtilizationType === 'averageUtilization' || !props.selectedUtilizationType) ?
                                <Button className="switcher-button" kind='ghost' onClick={() => props.toggleUtilization('peakUtilization')}>{DashboardConstants.SwitchToPeakUtilization}</Button>
                                :
                                <Button className="switcher-button" kind='ghost' onClick={() => props.toggleUtilization('averageUtilization')}>{DashboardConstants.SwitchToAverageUtilization}</Button>
                            }
                        </div>
                    </div>
                    <div className="graph-action-items">
                        <div className="download-button">
                            <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.downloadableData} headers={props.downloadableHeader} title={props.title+" "+props.selectedVMTableView} filename={props.title+props.selectedVMTableView} label={DashboardConstants.Download} />
                        </div>
                    </div>
                </div>
                <div className="graph-filter-items">
                        <div>
                            <MultiSelect
                                ariaLabel="MultiSelect"
                                id="excludeDays"
                                items={props.days}
                                itemToString={(item) => (item ? item.label : '')}
                                sortItems={(items) => (items)}
                                label={DashboardConstants.SelectDays}
                                titleText={DashboardConstants.ExcludeDays}
                                onChange={props.filterUtilizationByDays}
                            />
                        </div>
                        <div>
                            <NumberInput
                                id="excludeSecs"
                                label={DashboardConstants.ExcludeSeconds}
                                placeholder={DashboardConstants.Eg90}
                                min={0}
                                onChange={props.filterUtilizationByTime}
                                allowEmpty={true}
                            />
                        </div>
                        <div>
                            {DashboardConstants.Resources}
                            <div className="info">{DashboardConstants.ChangeResources}</div>
                            {/* {defaultLineGraphOptions.data.loading ?
                                <TextInputSkeleton />
                                :
                                <MultiSelect
                                    ariaLabel="MultiSelect"
                                    id="selectedResources"
                                    items={props.vmList}
                                    itemToString={(item) => (item ? item : '')}
                                    label="Resources"
                                    titleText="Resource name (upto 15 resources)"
                                    initialSelectedItems={props.selectedResources}
                                    onChange={props.filterUtilizationByResources}
                                />
                            } */}
                        </div>
                    </div>
                    {props.selectedVMTableView === 'hrView' || props.selectedVMTableView === 'dayView' ?
                        !defaultLineGraphOptions.data.loading && !props.lineGraphData.length ?
                        <div>{DashboardConstants.NoDataAvailable}</div>
                        :
                        <LineChart
                            data={props.lineGraphData}
                            options={defaultLineGraphOptions}>
                        </LineChart>
                        :
                        ''
                    }
            </div>
        </>
    );
};

export default CustomLineChart;
